/** Visina promo trake u fiksnom headeru (px) — drži usklađenim s PromoMarquee. */
export const PROMO_MARQUEE_HEIGHT_PX = 32;

const TOOLBAR_HEIGHT = { xs: 56, sm: 64 } as const;

/** Ukupna visina fiksnog headera (toolbar + promo traka), u theme spacing jedinicama (8px). */
export const appBarOffsetSpacing = {
    xs: (TOOLBAR_HEIGHT.xs + PROMO_MARQUEE_HEIGHT_PX) / 8,
    sm: (TOOLBAR_HEIGHT.sm + PROMO_MARQUEE_HEIGHT_PX) / 8,
} as const;

/** Sticky offset ispod cijelog headera + mali razmak (px). */
export const stickyTopBelowHeader = {
    xs: TOOLBAR_HEIGHT.xs + PROMO_MARQUEE_HEIGHT_PX + 8,
    sm: TOOLBAR_HEIGHT.sm + PROMO_MARQUEE_HEIGHT_PX + 8,
} as const;
